contact_translations = {
	media_queries: {
		en: "Media Queries:",
		cn: "媒体咨询：",
		es: "Preguntas sobre medios:",
		pt: "Perguntas sobre a mídia:",
		ru: "Запросы СМИ:"
	},
	contact_overline: {
		en: 'For general media inquiries, please email us at: <a href="mailto:media.requests@gulfstream.com">media.requests@gulfstream.com</a>.',
		cn: "如有媒体查询，请联系以下人员。请注意，列出的联系方式仅供媒体人士使用。",
		es: "Para toda consulta de medios sobre asuntos generales, comuníquese con las personas que figuran a continuación. Tenga en cuenta que los contactos que se indican solo están disponibles para los miembros de los medios.",
		pt: "Para consultas gerais da mídia, entre em contato com as pessoas indicadas a seguir. Observe que os contatos mencionados estão disponíveis apenas para membros da mídia.",
		ru: "Запросы от СМИ общего характера следует направлять указанным ниже лицам. Обратите внимание, что указанные контакты доступны только представителям СМИ."
	},
	"business/industry,_leadership,_r&d,_technology_and_innovation,_customer_support,_sustainability,_community/facilities": {
		en: "Business/Industry, Leadership, R&D, Technology and Innovation, Customer Support, Sustainability, Community/Facilities",
		cn: "业务/行业，领导力，研发，技术和创新，客户支持，可持续发展，社区/设施",
		es: "Negocios/Industria, Liderazgo, I+D, Tecnología e Innovación, Soporte al cliente, Sostenibilidad, Comunidad/Instalaciones",
		pt: "Negócios/Indústria, Liderança, P&D, Tecnologia e inovação, Suporte ao cliente, Sustentabilidade, Comunidade/Instalações",
		ru: "Бизнес/промышленность, лидерство, исследования и разработки, технологии и инновации, клиентская поддержка, устойчивое развитие, сообщество/объекты"
	},
	"g800,_g700,_g400,_special_missions,_interior_design": {
		en: "G800, G700, G400, Special Missions, Interior Design",
		cn: "G800，G700，G400，特殊任务，内饰设计",
		es: "G800, G700, G400, Misiones Especiales, Diseño Interior",
		pt: "G800, G700, G400, Missões especiais, Design de interiores",
		ru: "G800, G700, G400, специальные миссии, дизайн интерьера"
	},
	"g650_and_g650er,_g600,_g500,_g280": {
		en: "G650 and G650ER, G600, G500, G280",
		cn: "G650 和G650ER，G600，G500，G280",
		es: "G650 y G650ER, G600, G500, G280",
		pt: "G650 e G650ER, G600, G500, G280",
		ru: "G650 и G650ER, G600, G500, G280"
	},
	g280: {
		en: "G280",
		cn: "G280",
		es: "G280",
		pt: "G280",
		ru: "G280"
	},
	event_queries: {
		en: "Event Queries:",
		cn: "活动咨询：",
		es: "Preguntas sobre eventos:",
		pt: "Perguntas sobre eventos:",
		ru: "Запросы по событиям:"
	},
	advertising_queries: {
		en: "Advertising Queries:",
		cn: "广告咨询：",
		es: "Preguntas sobre publicidad:",
		pt: "Perguntas sobre publicidade:",
		ru: "Рекламные запросы:"
	}
};
